module.exports = __webpack_public_path__ + "img/antes_despues_129.ae0b3e5f.png";